import React from "react";

import { ProductTileContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";
import { useProductTileClickImpressions } from "@faire/retailer/hooks/ProductTileImpression/useProductTileClickImpressions";

import { ProductClickForSearchPageParameters } from "./useOnProductClickForSearchPage";

export const useGetProductTileClickImpressions = (
  params: ProductClickForSearchPageParameters
) => {
  const productTileContext = React.useContext(ProductTileContext);

  return useProductTileClickImpressions(
    params,
    productTileContext.brand,
    productTileContext.recordAdImpression
  );
};
